import React from 'react';
import classnames from 'classnames';
import RadioButton from '@wix/da-ds/pkg/RadioButton';
import s from './LayoutRadioButton.scss';
const LayoutRadioButton = ({ label , value , onChange , icon: Icon , checked =false  })=>/*#__PURE__*/ React.createElement(RadioButton, {
        name: "layout",
        value: value,
        onChange: onChange,
        checked: checked,
        className: classnames(s['root'], checked && s['checked']),
        inputClassName: s['input'],
        size: "small",
        withMargins: true
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: s['icon'],
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['label']
    }, label));
export default LayoutRadioButton;
